<template>
    <div class="row py-3 border-bottom border-secondary"  :class="{'bg-muted text-muted':  isBeforeToday}"
    >
        <div class="col-1"  v-if="$root.isAdmin">
            {{ pickup.company.name }}
        </div>
        <div class="col-2">
            {{ pickup.address }}<br />
            {{ pickup.postal_code }}<br />
            {{ pickup.city }}<br />
            {{ pickup.country }}
        </div>
        <div class="col-2 text-nowrap">
                <div class="row" v-for="(info,index) in pickup.sums" :key="'pickup-sum-' + index" v-if="info > 0">
                    <div class="col-6">{{ $t('pickup.sums.' + index) }}</div>
                    <div class="col-6">{{ info }}</div>
                </div>
        </div>
        <div class="col-2">
            {{ pickupDate }}<br /><br />
            {{ $t('pickup.fields.time') }}<br />
            {{ pickupTime }}
        </div>
        <div class="col-2">
            {{ pickup.contact_name }}<br />
            {{ pickup.contact_email }}<br />
            {{ pickup.contact_phone }}
        </div>
        <div :class="{'col-2': $root.isAdmin, 'col-3': !$root.isAdmin}">
            {{ pickup.instructions }}
        </div>
        <div class="col-1">
            <a :href="bookingLink" v-if="hasBookings">{{ $t('pickup.seeBookings') }}<br /></a>
            <a href="#" @click="showLoadingList" v-if="hasBookings">{{ $t('pickup.sendLoadingList') }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PickupIndexItem',
    props: ['pickup'],
    computed: {
        pickupDate() {
            return this.$moment.utc(this.pickup.pickup_at).tz(this.$moment.tz.guess()).format('LL')
        },
        pickupTime(){
          return this.pickup.time_for_pickup.substring(0,5);
        },
        isBeforeToday(){
            return this.$moment.utc(this.pickup.pickup_at).isBefore(this.$moment(), 'day')
        },
        hasBookings(){
            return this.pickup.bookings.length > 0;
        },
        bookingLink(){
            return '/bookings?highlight=' + this.pickup.bookings.map(item => item.id).join(',');
        }
    },
    methods: {
        showLoadingList () {
            this.$emit('showLoadingList', this.pickup);
        }
    }
}
</script>
